import { SubscriptionType } from './credit-service-dtos';

export interface SubscriptionPlan {
    type: SubscriptionType;
    price: string;
    period: TimeIntervalType;
    descriptionKeys: string[];
    inclusiveCreditsAmount: string;
}

export interface SubscriptionMeta {
    translationKey: string;
    displayName: string;
}

export const SUBSCRIPTION_META: Partial<
    Record<SubscriptionType, SubscriptionMeta>
> = {
    [SubscriptionType.FREE]: {
        translationKey: 'free',
        displayName: 'Free',
    },
    [SubscriptionType.STARTER]: {
        translationKey: 'starter',
        displayName: 'Starter',
    },
    [SubscriptionType.SINGLE_USER]: {
        translationKey: 'singleUser',
        displayName: 'Single User',
    },
    [SubscriptionType.POWER_USER]: {
        translationKey: 'powerUser',
        displayName: 'Power User',
    },
    [SubscriptionType.TEAM]: {
        translationKey: 'team',
        displayName: 'Team',
    },
};

export enum TimeIntervalType {
    MONTHLY = 'monthly',
    YEARLY = 'yearly',
    NONE = 'none',
}

const SUBSCRIPTION_PLANS: { [key: string]: SubscriptionPlan } = {
    FREE: {
        type: SubscriptionType.FREE,
        price: '0',
        period: TimeIntervalType.NONE,
        descriptionKeys: [],
        inclusiveCreditsAmount: '0',
    },
    STARTER: {
        type: SubscriptionType.STARTER,
        price: '11,90',
        period: TimeIntervalType.MONTHLY,
        descriptionKeys: ['apiAccess', 'trainingExecution', 'skillDownload'],
        inclusiveCreditsAmount: '30',
    },
    SINGLE_USER: {
        type: SubscriptionType.SINGLE_USER,
        price: '59,50',
        period: TimeIntervalType.MONTHLY,
        descriptionKeys: ['apiAccess', 'trainingExecution', 'skillDownload'],
        inclusiveCreditsAmount: '200',
    },
    POWER_USER: {
        type: SubscriptionType.POWER_USER,
        price: '357',
        period: TimeIntervalType.MONTHLY,
        descriptionKeys: [
            'apiAccess',
            'trainingExecution',
            'skillDownload',
            'organisationStructure',
        ],
        inclusiveCreditsAmount: '2000',
    },
    TEAM: {
        type: SubscriptionType.TEAM,
        price: '357',
        period: TimeIntervalType.MONTHLY,
        descriptionKeys: ['apiAccess', 'trainingExecution', 'skillDownload'],
        inclusiveCreditsAmount: '2000',
    },
};

export const ORGANIZATION_CONTEXT_SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
    SUBSCRIPTION_PLANS['FREE'],
    SUBSCRIPTION_PLANS['TEAM'],
];
export const PRIVATE_CONTEXT_SUBSCRIPTION_PLANS: SubscriptionPlan[] = [
    SUBSCRIPTION_PLANS['FREE'],
    SUBSCRIPTION_PLANS['STARTER'],
    SUBSCRIPTION_PLANS['SINGLE_USER'],
    SUBSCRIPTION_PLANS['POWER_USER'],
];

export const SEATS = {
    [SubscriptionType.FREE]: '1',
    [SubscriptionType.TEAM]: '5',
};
